package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_01_25_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-01-25")
@Composable
public fun Log_2025_01_25(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Do’Shara, Final Boss of Desert Wing",
        ogTitle = "Do’Shara, Final Boss of Desert Wing",
        date = LocalDate(2_025, 1, 25),
        ogDescription = "Heroes slaughter henchmen. Samuel Thardos, Duke of Brij, is the blue dragon.",
        ogImage = "ai/2025-01-25.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
        Log_2025_01_25_Day_1()
    }
}
